/** @file setLiveChords: points the menus' chord lookup at the key tables and overrides now in force. */
import type { Binding } from '@zilo/pose3d-shortcuts/types';
import { liveChordState } from './liveChordState';

/** Called by `App` whenever the tables or the overrides change (Settings rebinding included). */
export function setLiveChords(tables: Binding[][], overrides: Binding[]): void {
  liveChordState.tables = tables;
  liveChordState.overrides = overrides;
}
